module.exports = __webpack_public_path__ + "img/appAsset--el-ax.60255763.svg";